import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_456: DocMigration = {
  maxSchemaVersion: "0.0.456",
  description: "Remove all presets with type 'HOME_PLAN' from the doc.",
  apply(json: any): any {
    if (json.presets) {
      for (const presetId of Object.keys(json.presets)) {
        const preset = json.presets[presetId];
        if (preset.type === "HOME_PLAN") {
          delete json.presets[presetId];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_456;
